export const environment = {
  customerCode: '',
  gMapKey: '',
  production: false,
  apiUrl: '',
  hostUrl: '',
  logoPath: '',
  eyeShow: '',
  eyeHide: '',
  cost: '',
  costActive: '',
  createShipment: '',
  createShipmentActive: '',
  checkShipment: '',
  checkShipmentActive: '',

  apiPartnerPost: '',
  apiPartnerCore: '',
  apiUrlVSE: ''
};

const hostName = location.hostname.split('.')[0];
const DomainCustomer = hostName.toString();


switch (DomainCustomer) {
  default:
    environment.customerCode = null;
    environment.production = false;
    environment.gMapKey = 'AIzaSyAn9BO6vqmSlwtliWaH6fPqviZ2hRG0y74';
    // environment.gMapKey = 'AIzaSyDkGzxX4Y5_pgefw-zpFU1vWRo5hnkTweI';
    environment.logoPath = '';
    environment.apiUrl = 'http://admin-api.vantaitruongthinhphat.com/api';
    environment.hostUrl = 'http://admin-api.vantaitruongthinhphat.com';
    // environment.apiUrl = 'http://localhost:52724/api',
    // environment.hostUrl = 'http://localhost:52724/',
    environment.eyeShow = 'assets/layout/images/icon-pasword/eye-icon.svg';
    environment.eyeShow = 'assets/layout/images/icon-pasword/eye-icon.svg';
    environment.eyeHide = 'assets/layout/images/icon-pasword/eye-hidden-icon.svg';
    environment.cost = 'assets/App_Themes/images/icon-1.png';
    environment.costActive = 'assets/App_Themes/images/icon-popup-1.png';
    environment.createShipment = 'assets/App_Themes/images/icon-2.png';
    environment.createShipmentActive = 'assets/App_Themes/images/icon-popup-2.png';
    environment.checkShipment = 'assets/App_Themes/images/icon-3.png';
    environment.checkShipmentActive = 'assets/App_Themes/images/icon-popup-3.png';

    // environment.apiUrlVSE = 'http://web-ttp-api.ssw.vn/api';
    // environment.apiPartnerPost = 'http://web-ttp-api.ssw.vn/api';
    // environment.apiPartnerCore = 'http://web-ttp-api.ssw.vn/api';
    break;
}
